import { render, staticRenderFns } from "./MetabaseEmbed.vue?vue&type=template&id=3975e6ba&"
import script from "./MetabaseEmbed.vue?vue&type=script&lang=js&"
export * from "./MetabaseEmbed.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src3554887359/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3975e6ba')) {
      api.createRecord('3975e6ba', component.options)
    } else {
      api.reload('3975e6ba', component.options)
    }
    module.hot.accept("./MetabaseEmbed.vue?vue&type=template&id=3975e6ba&", function () {
      api.rerender('3975e6ba', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/MetabaseEmbed.vue"
export default component.exports